import type { RetargetingDisposition, RetargetingSegmentOption } from '@openx/types/targeting/retargeting.ts';
import type { RetargetingSegmentsQuery } from '../../../graphql/query/segments/GetRetargetingSegments.generated.tsx';

type RoutedSegment = NonNullable<RetargetingSegmentsQuery['routedSegments'][number]>;
export type RetargetingSegmentQueryItem = Extract<RoutedSegment, { __typename?: 'RetargetingSegment' }>;

export const mapRetargetingSegmentOption = (segment: RetargetingSegmentQueryItem): RetargetingSegmentOption => ({
  id: segment.id,
  name: segment.name ?? segment.id,
  disposition: segment.disposition,
});

export const mapEligibleRetargetingSegments = ({
  routedSegments,
  accountUid,
  disposition,
}: {
  routedSegments: RoutedSegment[];
  accountUid?: string;
  disposition: RetargetingDisposition | '';
}): {
  segments: Record<string, RetargetingSegmentOption>;
  segmentsList: string[];
} => {
  if (!disposition) {
    return { segments: {}, segmentsList: [] };
  }

  const eligibleSegments = routedSegments
    .filter((obj): obj is RetargetingSegmentQueryItem => obj.__typename === 'RetargetingSegment')
    .filter(segment => !accountUid || segment.account_uid === accountUid)
    .filter(segment => segment.disposition === disposition)
    .map(mapRetargetingSegmentOption);

  return {
    segments: Object.fromEntries(eligibleSegments.map(segment => [segment.id, segment])),
    segmentsList: eligibleSegments.map(segment => segment.id),
  };
};
